export default __webpack_public_path__ + "static/media/pokiBoard@3x.97a369bd.png";